import ErrorBoundary from "components/Error/errorBoundary"
import React from "react";
import {useFormContext} from "react-hook-form";
import useConditionalField from "v4/components/form/Field/hooks/useConditionalField";
import {useProspectPageContext} from "v4/contexts/ProspectPageContext";
import QuotesProductsDetails from "v4/features/front/products/components/QuotesProductsDetails/QuotesProductsDetails";

export default function QuoteLines({name, attr, tip, properties}) {
    const {quote} = useProspectPageContext();
    const {getFieldState, formState} = useFormContext();
    const {error} = getFieldState(name, formState);
    const hideField = useConditionalField(attr?.['data-condition-field'], attr?.['data-condition-value']);

    if (hideField) return null;

    return (
        <>
            {tip && <p className="inpu-field__tip">{tip}</p>}
            {error && <p className="input-field__errors">{error.message}</p>}

            <ErrorBoundary>
                <QuotesProductsDetails isShow={quote?.metadata?.splitType === 'parent'} properties={properties}/>
            </ErrorBoundary>
        </>
    )
}
